import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { LibCoreLayoutModule } from '../core-layout/core-layout.module';
import { PhoneNumberInputComponent } from './phone-number-input.component';
import { FlexModule } from '@angular/flex-layout';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  imports: [
    CommonModule,
    LibCoreLayoutModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    // material design
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FlexModule,
  ],
  declarations: [PhoneNumberInputComponent],
  exports: [PhoneNumberInputComponent],
})
export class PhoneNumberInputModule {}
